import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import Modal from '../../../../../common/modals/Modal';
import { apiPostJson as apiPost } from '../../../../../../utils/api';

// Single-candidate invite: confirm/enter the contact email, then send.
export default function InviteModal({ candidate, onClose, onInvited }) {
  const [email, setEmail] = useState(candidate.contact_email || '');
  const [includeChildren, setIncludeChildren] = useState(false);
  const [busy, setBusy] = useState(false);
  const qualifying = candidate.qualifying_children_count || 0;

  const send = async () => {
    setBusy(true);
    try {
      const res = await apiPost(`/admin/service_comp_candidates/${candidate.id}/invite`, {
        contact_email: email,
        include_children: includeChildren,
      });
      const extra = res.children_comped ? ` (+${res.children_comped} children)` : '';
      toast.success(`Invited ${candidate.company_name || 'client'}${extra}`);
      onInvited();
    } catch (e) {
      toast.error('Invite failed (is the comp plan configured?)');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      title={`Invite ${candidate.company_name || 'client'}`}
      footer={(
        <>
          <button onClick={onClose} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded mr-2">Cancel</button>
          <button onClick={send} disabled={busy || !email}
            className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 disabled:opacity-50">
            Send invite
          </button>
        </>
      )}
    >
      <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">
        Sends a complimentary-access email and creates a comped subscription.
      </p>
      <label className="block text-sm font-medium mb-1 dark:text-gray-200">Contact email</label>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="ops@company.com"
        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 dark:text-white"
      />
      {qualifying > 0 && (
        <label className="flex items-start gap-2 mt-4 text-sm dark:text-gray-200">
          <input type="checkbox" className="mt-0.5" checked={includeChildren} onChange={(e) => setIncludeChildren(e.target.checked)} />
          <span>
            Also comp <strong>{qualifying}</strong> qualifying child {qualifying === 1 ? 'company' : 'companies'}
            <span className="block text-xs text-gray-500 dark:text-gray-400">
              Children with a portal account and recent file activity — each gets its own complimentary access.
            </span>
          </span>
        </label>
      )}
    </Modal>
  );
}
